import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const Facebook = ({ color = "offWhite" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 28 28"
      fill="none"
      className="w-3 h-3 sm:w-6 sm:h-6"
    >
      <path
        d="M13.1895 2.40831C6.78848 2.85592 1.91668 8.44771 2.36672 14.8837C2.77364 20.7028 7.37097 25.2348 12.9951 25.7187L12.4254 17.5719L9.4693 17.7786L9.23329 14.4035L12.1894 14.1968L12.0095 11.6247C11.8053 8.70354 13.4271 6.9762 16.0922 6.78984C17.3608 6.70113 18.703 6.82948 18.703 6.82948L18.904 9.70413L17.4376 9.80667C15.9945 9.90758 15.6032 10.8355 15.6675 11.7549L15.8205 13.9429L19.056 13.7166L18.7683 17.1283L16.0565 17.318L16.6262 25.4647C19.3384 24.8398 21.7379 23.2659 23.3914 21.0271C25.0449 18.7883 25.8436 16.032 25.6432 13.256C25.1932 6.82006 19.5906 1.96071 13.1895 2.40831Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default Facebook;
